import { render, staticRenderFns } from "./ConsultationInviteSent.vue?vue&type=template&id=d4cb1f92&scoped=true"
import script from "./ConsultationInviteSent.vue?vue&type=script&lang=js"
export * from "./ConsultationInviteSent.vue?vue&type=script&lang=js"
import style0 from "./ConsultationInviteSent.vue?vue&type=style&index=0&id=d4cb1f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cb1f92",
  null
  
)

export default component.exports